(function () {
  const initUspSlider = () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-usp-slider]').forEach((sliderEl) => {
      if (sliderEl.dataset.initialized === 'true') return;
      sliderEl.dataset.initialized = 'true';

      const paginationEl = sliderEl.querySelector('.usp-banner__pagination');

      new Swiper(sliderEl, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: paginationEl ? {
            el: paginationEl,
            clickable: true,
        } : undefined,
        breakpoints: {
            768: {
                slidesPerView: 2,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            },
            1240: {
                slidesPerView: 3,
                loop: false,
                autoplay: false,
                allowTouchMove: false,
            },
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initUspSlider);
  document.addEventListener('shopify:section:load', initUspSlider);
})();
